var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),(_vm.$store.state.loading)?_c('Loading'):_vm._e(),(_vm.$store.state.formSuccess)?_c('Success'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }